<template>
    <el-select :value="categoryName" class="select" clearable filterable :placeholder="$t('shared.pleaseSelectCode')" :loading="loading" @change="change">
        <el-option  v-for="item in categories" :label="item" :value="item"></el-option>
    </el-select>
</template>

<script>
    import api from './api'
    export default {
        name: 'category-selector',
        data() {
            return {
                loading: false,
                categories: [],
                categoryName: ''
            }
        },
        created: function () {
                this.loading = true
            api.getCategories().then(response => {
                    this.loading = false
                    this.categories = response.data
                })
        },
        methods: {
            change(val) {
                if (val) {
                    this.categoryName = val;
                    this.$emit('category-selected', val)
                }
            },
  
        }
    }
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/categoryselector/CategorySelector.vue